import { ClientItem, mailStore } from 'owa-mail-store';
import getFirstBody from './getFirstBody';
import getQuotedTextList from './getQuotedTextList';

const sizeLimit: number = 400000;

export default function checkItemUnderSizeLimit(
    itemId: string,
    isConversationItemPart: boolean = false
): boolean {
    let size = 0;
    const item: ClientItem = mailStore.items.get(itemId);
    let firstBodyText: string = getFirstBody(item, isConversationItemPart);

    if (firstBodyText) {
        size += firstBodyText.length;
    }
    if (isConversationItemPart) {
        const quotedTextList: string[] = getQuotedTextList(item);

        if (quotedTextList) {
            quotedTextList.forEach(quotedText => {
                size += quotedText.length;
            });
        }
    }
    return size < sizeLimit;
}
